module.exports = __webpack_public_path__ + "static/img/slide2.d8004dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor3/slide2.png
// module id = 1ZbJ
// module chunks = 2